export default __webpack_public_path__ + "static/media/memoriesLogo.3515da33.png";